import { useEffect, useState } from "react";
import { ExperimentFlags } from "@shared/utils.experimentation";
import { useFeatureFlag } from "../../../../../hooks";
import { QuizInsert } from "../QuizInsert";
import { OrderItAgain } from "../OrderItAgain";
import { useFavourites } from "../../../../../packages/membership/pages/Favourites/hooks/useFavourites";
import { useExperimentViewed } from "tracking/hooks/useExperimentViewed";

export const DefaultComponentOnSearch = () => {
  const { reorderProducts } = useFavourites({
    currentPage: 1,
    type: "order_it_again"
  });

  const [hasOrderItAgain, setHasOrderItAgain] = useState(false);

  const [isLoading, showOiaOnSearch] = useFeatureFlag(
    ExperimentFlags.SHOW_OIA_ON_SEARCH,
    "0"
  );

  useEffect(() => {
    setHasOrderItAgain(reorderProducts.products?.length > 0);
  }, [reorderProducts]);

  const shouldShowOia =
    !isLoading && showOiaOnSearch === "1" && hasOrderItAgain;

  const trackExperimentViewed = useExperimentViewed();

  useEffect(() => {
    if (hasOrderItAgain) {
      if (showOiaOnSearch === "1") {
        trackExperimentViewed(ExperimentFlags.SHOW_OIA_ON_SEARCH, 1);
      } else {
        trackExperimentViewed(ExperimentFlags.SHOW_OIA_ON_SEARCH, 0);
      }
    }
  }, [trackExperimentViewed, hasOrderItAgain, showOiaOnSearch]);

  return shouldShowOia ? <OrderItAgain /> : <QuizInsert />;
};
